export const SET_PROJECT = "@SETTINGS_PROJECT/SET_PROJECT";
export const SET_PROJECT_TEMPLATES = "@SETTINGS_PROJECT/SET_PROJECT_TEMPLATES";
export const SET_PROJECT_LANGUAGES = "@SETTINGS_PROJECT/SET_PROJECT_LANGUAGES";
